var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TelemetryEventBaseOverlay',[_c('hr',{staticClass:"m-0 mb-4"}),_c('div',{staticClass:"data d-flex justify-content-around align-items-center"},[_c('div',{staticClass:"item px-3 py-1 mx-1 d-flex justify-content-between align-items-center flex-column"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.eventRawData.warning))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }